const isAssetImageChecker = (fileExtension) => {
  const fileExtensionCheck = (fileExtension || '').toLowerCase();
  return fileExtensionCheck === 'jpg' || fileExtensionCheck === 'png' || fileExtensionCheck === 'jpeg';
};

export default isAssetImageChecker;
